function testFunction () {
	console.log('lol tigers');
}

$(document).ready(function() {
	$('#cat').change(function() {
		$('#searchformcat').submit();
	})

	// $('.home-slideshow').flexslider({
	// 	selector: '.home-banner',
	// 	controlNav: false,
	// 	directionNav: false,
	// 	start: function() {
	// 		$('.home-banner').show();
	// 	}
	// });

	

	$('.folder-heading').click(function(e) {
		e.preventDefault();
	});

	$('.folder:first-child .folder-content').slideDown();

	$('.folder').click(function() {

		var t = $(this);

		$('.folder-content',t).slideToggle();

		if (t.hasClass('closed')) {
			t.removeClass('closed').addClass('open');
		} else {
			t.removeClass('open').addClass('closed');
		}

	})

	slideShow();

	addMobileMenuPlusses();


	$('.mobile-menu a').click(function(e) {
		e.preventDefault();
		$('#menu-main-menu').slideToggle();
	})

})

function slideShow() {

	
	$('#slide-0').clone().insertAfter('.home-banner:last-child').attr('id','last');
	var slides = $('.home-banner');
	var total = slides.length;
	var speed = 7000;
	var curr = 0;


	slides.show();

	slides.each(function(i) {
		var t = $(this);
		t.css({'z-index':(total-i)})
	})

	slideLoop = function() {

		$('#slide-'+curr).fadeOut(500,function() {
			curr++;
			if (curr == (total-1)) {
				curr = 0;
				$('.home-banner').show();
			}
			setTimeout(slideLoop,speed);
		})
		

	};

	setTimeout(slideLoop,speed);

}

function addMobileMenuPlusses() {
	$('header .menu-item-has-children').each(function() {
		$(this).append('<span class="mobile-menu-plus">+</span>');
	});
	$('.mobile-menu-plus').click(function() {
		$(this).prev().slideToggle();
		$(this).html($(this).html() == '+' ? '-' : '+');
	});
}